import {Injectable, OnInit} from '@angular/core';
// import {Observable, Subject} from "rxjs/Rx";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";

import {JsonApiService} from "../../core/api/json-api.service";
import {AuthService} from "../../+auth/auth.service";

@Injectable()
export class UserService {

  public user: Subject<any>;

  public userInfo = {
    username: 'Guest'
  };

  profile: any;

  constructor(private jsonApiService:JsonApiService, private auth: AuthService) {
    this.user = new Subject();

      // if (this.auth.userProfile) {
      //     this.profile = this.auth.userProfile;
      //
      // } else {
      //     this.auth.getProfile((err, profile) => {
      //         this.profile = profile;
      //
      //     });
      // }

      // this.auth.getProfile((err, profile => {this.pro}).subscribe(item => {
      //   this.profile = item;
      //   console.log('profile_Subscription = ', this.profile);
      // })

  }


  getLoginInfo() {

      // this.profile.forEach(item => {
      //     console.log('profile = ', item);
      // })
      // if (this.auth.userProfile) {
      //     this.profile = this.auth.userProfile;
      //
      // } else {
      //     this.auth.getProfile((err, profile) => {
      //         this.profile = profile;
      //
      //     });
      // }
      // console.log('profile = ', this.profile);
      //
      //
      // return this.profile;

      // return this.jsonApiService.fetch('/user/login-info.json')
      //     .do((user)=>{
      //         this.userInfo = this.profile;
      //         // this.userInfo.username = this.profile.name;
      //         console.log('userService = ', this.userInfo);
      //         this.user.next(this.profile)
      //     })

    return this.jsonApiService.fetch('/user/login-info.json')
      .do((user)=>{
        this.userInfo = user;
        // this.userInfo.username = this.profile.name;
          console.log('userService = ', this.userInfo);
      this.user.next(user)
    })
  }

  // getLoginInfo():Observable<any> {
  //     if (this.auth.userProfile) {
  //         this.user = this.auth.userProfile;
  //     } else {
  //         this.auth.getProfile((err, profile) => {
  //             this.user = profile;
  //         });
  //     }
  //     return this.user;
  // }

}


//====================
// profile: any;
//
// constructor(private jsonApiService:JsonApiService, private auth: AuthService) {
//     this.user = new Subject();
//
//     // if (this.auth.userProfile) {
//     //     this.profile = this.auth.userProfile;
//     //     console.log('11111111');
//     //
//     // } else {
//     //     this.auth.getProfile((err, profile) => {
//     //         this.profile = profile;
//     //         console.log('11111111==========');
//     //         console.log(this.profile);
//     //
//     //     });
//     // }
//
//     // this.auth.getProfile((err, profile => {this.profile = profile}).subscribe(item => {
//     //   this.profile = item;
//     //   console.log('profile_Subscription = ', this.profile);
//     // })
//
// }
//
//
// getLoginInfo() {
//
//     // this.profile.forEach(item => {
//     //     console.log('profile = ', item);
//     // })
//     if (this.auth.userProfile) {
//         this.profile = this.auth.userProfile;
//         console.log('11111111');
//
//     } else {
//         this.auth.getProfile((err, profile) => {
//             this.profile = profile;
//             this.user = profile;
//             console.log('11111111==========');
//             console.log(this.user);
//
//
//
//         });
//     }
//     return Observable.of(this.user);


// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/user/user.service.ts